<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3"><a id="page_10"><strong><em>Abbreviations</em></strong></a></h1><a id="page_10">
<table>
<tbody>
<tr>
<td class="col15"><p class="t-right">ET</p></td>
<td class="col80"><p class="t-hang">English Translation</p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>NICNT</em></p></td>
<td class="col80"><p class="t-hang"><em>New International Commentary on the New Testament</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>NTD</em></p></td>
<td class="col80"><p class="t-hang"><em>Das Neue Testament Deutsch</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>NTS</em></p></td>
<td class="col80"><p class="t-hang"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>PRE</em></p></td>
<td class="col80"><p class="t-hang"><em>Realencyclopädie für protestantische Theologie und Kirche</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>RGG</em></p></td>
<td class="col80"><p class="t-hang"><em>Religion in Geschichte und Gegenwart</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>TDNT</em></p></td>
<td class="col80"><p class="t-hang"><em>Theological Dictionary of the New Testament</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>TLZ</em></p></td>
<td class="col80"><p class="t-hang"><em>Theologische Literaturzeitung</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>TZ</em></p></td>
<td class="col80"><p class="t-hang"><em>Theologische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>ZNW</em></p></td>
<td class="col80"><p class="t-hang"><em>Zeitschrift für die neutestamentliche Wissenschaft</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>ZST</em></p></td>
<td class="col80"><p class="t-hang"><em>Zeitschrift für systematische Theologie</em></p></td>
</tr>
<tr>
<td class="col15"><p class="t-right"><em>ZTK</em></p></td>
<td class="col80"><p class="t-hang"><em>Zeitschrift für Theologie und Kirche</em></p></td>
</tr>
</tbody>
</table>
<p class="fm-head"><strong>COMMENTARIES FREQUENTLY CITED</strong></p>
<table>
<tbody>
<tr>
<td class="col30"><p class="t-right">Althaus, <em>Rom</em>.</p></td>
<td class="col65"><p class="t-hang">P. Althaus, <em>Der Brief an die Römer</em> (Das Neue Testament Deutsch, 6), 6th ed., 1949.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Dibelius, <em>Th</em>.</p></td>
<td class="col65"><p class="t-hang">M. Dibelius, <em>An die Thessalonicher</em> (Handbuch zum Neuen Testament), 3rd ed., 1937.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Dibelius, <em>Col</em>.</p></td>
<td class="col65"><p class="t-hang">M. Dibelius (rev. Greeven), <em>An die Kolosser, Epheser, An Philemon</em> (Handbuch zum Neuen Testament, 12), 3rd ed., 1953.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Greijdanus, <em>Rom</em>.</p></td>
<td class="col65"><p class="t-hang">S. Greijdanus, <em>De Brief van den apostel Paulus aan de Gemeente te Rome</em>, I, 1933; II, 1933.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Grosheide, <em>1 Cor</em>.</p></td>
<td class="col65"><p class="t-hang">F. W. Grosheide, <em>De eerste brief van den apostel Paulus aan de kerk te Korinthe</em> (Commentaar op het Nieuwe Testament), 2nd ed., 1957.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Lietzmann, <em>Cor</em>., or Lietzmann-Kümmel, <em>Cor</em>.</p></td>
<td class="col65"><p class="t-hang">H. Lietzmann (rev. W. G. Kümmel), <em>An die Korinther</em> (Handbuch zum Neuen Testament, 9), 4th ed., 1949.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Lietzmann, <em>Rom</em>.</p></td>
<td class="col65"><p class="t-hang">H. Lietzmann, <em>An die Römer</em> (Handbuch zum Neuen Testament, 8), 4th ed., 1933.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Michel, <em>Rom</em>.</p></td>
<td class="col65"><p class="t-hang">O. Michel, <em>Der Brief an die Römer</em> (Kritisch-exegetischer Kommentar über das Neue Testament, 4), 1955.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Oepke, <em>Gal</em>.</p></td>
<td class="col65"><p class="t-hang">A. Oepke, <em>Der Brief des Paulus an die Galater</em> (Theologischer Handkommentar zum Neuen Testament, 9), 1937.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Ridderbos, <em>Col</em>.</p></td>
<td class="col65"><p class="t-hang">H. N. Ridderbos, <em>Aan de Kolossenzen</em> (Commentaar op het Nieuwe Testament), 1960.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Ridderbos, <em>Rom</em>.</p></td>
<td class="col65"><p class="t-hang">H. N. Ridderbos, <em>Aan de Romeinen</em> (Commentaar op het Nieuwe Testament), 1959.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Rigaux, <em>Th</em>.</p></td>
<td class="col65"><p class="t-hang">B. Rigaux, <em>Saint Paul: les épitres aux Thessaloniciens</em> (Études bibliques), 1956.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Schlier, <em>Gal</em>.</p></td>
<td class="col65"><p class="t-hang">H. Schlier, <em>Der Brief an die Galater</em> (Kritisch-exegetischer Kommentar über das Neue Testament, 7), 10th ed., 1949.</p></td>
</tr>
<tr>
<td class="col30"><p class="t-right">Wendland, <em>Cor</em>.</p></td>
<td class="col65"><p class="t-hang">H. D. Wendland, <em>Die Briefe an die Korinther</em> (Das Neue Testament Deutsch, 7), 5th ed., 1948.</p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Abbreviations.vue?29efc934